"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureInputMethod = exports.orderedSignatureTabs = exports.SignatureTab = exports.STANDARD_SCREEN_TEXT_SIGNATURE_FONT_SIZE = exports.SMALL_SCREEN_TEXT_SIGNATURE_FONT_SIZE = exports.STANDARD_SCREEN_TEXT_SIGNATURE_PADDING = exports.SMALL_SCREEN_TEXT_SIGNATURE_PADDING = exports.SMALL_SCREEN_BREAKPOINT = exports.MAX_UPLOAD_SIZE_IN_MB = exports.MB_IN_BYTES = exports.PIXEL_RATIO = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var signature_pad_1 = __importDefault(require("signature_pad"));
var inversify_react_1 = require("inversify-react");
var pages_common_1 = require("@qwilr/pages-common");
var Esignature_1 = require("@CommonFrontendBackend/Accept/Esignature");
var styles = __importStar(require("./ESignV3.css"));
var SelectorUtils_1 = require("@CommonFrontend/Utils/SelectorUtils");
var classnames_1 = __importDefault(require("classnames"));
exports.PIXEL_RATIO = 2;
exports.MB_IN_BYTES = 1024 * 1024;
exports.MAX_UPLOAD_SIZE_IN_MB = 50;
exports.SMALL_SCREEN_BREAKPOINT = 450;
exports.SMALL_SCREEN_TEXT_SIGNATURE_PADDING = 24;
exports.STANDARD_SCREEN_TEXT_SIGNATURE_PADDING = 40;
exports.SMALL_SCREEN_TEXT_SIGNATURE_FONT_SIZE = 28;
exports.STANDARD_SCREEN_TEXT_SIGNATURE_FONT_SIZE = 34;
var SignatureTab;
(function (SignatureTab) {
    SignatureTab["Type"] = "type";
    SignatureTab["Draw"] = "draw";
    SignatureTab["Upload"] = "upload";
    SignatureTab["Prefill"] = "prefill";
})(SignatureTab || (exports.SignatureTab = SignatureTab = {}));
exports.orderedSignatureTabs = [
    SignatureTab.Type,
    SignatureTab.Draw,
    SignatureTab.Upload,
];
var SignatureInputMethod;
(function (SignatureInputMethod) {
    SignatureInputMethod["Created"] = "created";
    SignatureInputMethod["Drawn"] = "drawn";
    SignatureInputMethod["Uploaded"] = "uploaded";
    SignatureInputMethod["Typed"] = "typed";
    SignatureInputMethod["Prefilled"] = "saved";
})(SignatureInputMethod || (exports.SignatureInputMethod = SignatureInputMethod = {}));
var Esign = (function (_super) {
    __extends(Esign, _super);
    function Esign(props) {
        var _this = _super.call(this, props) || this;
        _this.SHOW_DEBUG_PREVIEW = false;
        _this.currentTab = SignatureTab.Type;
        _this.disclaimerAccepted = false;
        _this.typeSignature = "";
        _this.typeSignatureData = "";
        _this.drawCanvasRef = react_1.default.createRef();
        _this.typeCanvasRef = react_1.default.createRef();
        _this.uploadCanvasRef = react_1.default.createRef();
        _this.drawSignatureData = "";
        _this.drawSignatureIsDirty = false;
        _this.isDraggingOverUpload = false;
        _this.hasUploadedImage = false;
        _this.uploadSignatureData = "";
        _this.prefilledSignatureData = "";
        _this.showSignaturePad = false;
        _this.handlePrefilledSignature = function (signature) { return __awaiter(_this, void 0, void 0, function () {
            var dataUrl;
            return __generator(this, function (_a) {
                if (signature) {
                    this.changeTab(SignatureTab.Prefill);
                    this.showSignaturePad = false;
                    dataUrl = (0, Esignature_1.esignatureDataToDataUrl)(signature);
                    this.prefilledSignatureData = dataUrl;
                    this.notifyChange();
                }
                else {
                    this.prefilledSignatureData = "";
                    this.changeTab(SignatureTab.Type);
                    this.showSignaturePad = true;
                    this.notifyChange();
                }
                return [2];
            });
        }); };
        _this.handleValidate = function () {
            var isPopulated = _this.currentTabIsPopulated;
            var isDisclaimerAccepted = _this.disclaimerAccepted;
            if (!isPopulated) {
                _this.setSignatureError("Please sign to accept the document");
            }
            else if (!isDisclaimerAccepted) {
                _this.setDisclaimerError("Please indicate that you agree to the terms and conditions to accept the document");
            }
            return isPopulated && isDisclaimerAccepted;
        };
        _this.handleDevFill = function (name) {
            _this.currentTab = SignatureTab.Type;
            _this.disclaimerAccepted = true;
            setTimeout(function () {
                _this.updateTypeSignature(name);
            }, 0);
        };
        _this.setSignatureError = function (message) {
            var _a;
            (_a = _this.signatureError) === null || _a === void 0 ? void 0 : _a.hide();
            _this.signatureError = _this.setErrorMsg(message, (0, SelectorUtils_1.toSelector)(styles.card()));
        };
        _this.setDisclaimerError = function (message) {
            var _a;
            (_a = _this.disclaimerError) === null || _a === void 0 ? void 0 : _a.hide();
            _this.disclaimerError = _this.setErrorMsg(message, (0, SelectorUtils_1.toSelector)(styles.disclaimer()));
        };
        _this.clearSignatureError = function () {
            var _a;
            (_a = _this.signatureError) === null || _a === void 0 ? void 0 : _a.hide();
            _this.signatureError = undefined;
        };
        _this.clearDisclaimerError = function () {
            var _a;
            (_a = _this.disclaimerError) === null || _a === void 0 ? void 0 : _a.hide();
            _this.disclaimerError = undefined;
        };
        _this.changeTab = function (tab) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentTab = tab;
                        this.signaturePad = undefined;
                        if (!(tab === SignatureTab.Draw)) return [3, 2];
                        return [4, this.initialiseDrawSignaturePad()];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2:
                        if (!(tab === SignatureTab.Upload)) return [3, 4];
                        return [4, this.updateUploadSignature()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.notifyChange();
                        return [2];
                }
            });
        }); };
        _this.initialiseCanvas = function (canvas) {
            var canvasContext = canvas.getContext("2d");
            if (canvas && canvasContext) {
                canvasContext.clearRect(0, 0, canvas.width, canvas.height);
                var ratio = exports.PIXEL_RATIO;
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvasContext.scale(ratio, ratio);
            }
        };
        _this.updateTypeSignature = function (newValue) {
            _this.typeSignature = newValue;
            var canvas = _this.typeCanvasRef.current;
            var canvasContext = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
            if (canvas && canvasContext) {
                _this.initialiseCanvas(canvas);
                var fontSize = exports.STANDARD_SCREEN_TEXT_SIGNATURE_FONT_SIZE;
                var padding = exports.STANDARD_SCREEN_TEXT_SIGNATURE_PADDING;
                if (window.innerWidth <= exports.SMALL_SCREEN_BREAKPOINT) {
                    fontSize = exports.SMALL_SCREEN_TEXT_SIGNATURE_FONT_SIZE;
                    padding = exports.SMALL_SCREEN_TEXT_SIGNATURE_PADDING;
                }
                canvasContext.font = "".concat(fontSize, "px Damion");
                canvasContext.fillStyle = "#242C39";
                canvasContext.fillText(newValue, padding, canvas.height / exports.PIXEL_RATIO - padding - 14, canvas.width / exports.PIXEL_RATIO - padding * 2);
                _this.typeSignatureData = canvas.toDataURL();
                _this.notifyChange();
            }
            else {
                throw new Error("Unable to update signature: couldn't find canvas");
            }
        };
        _this.updateDrawSignature = function () {
            _this.drawSignatureData = _this.signaturePad.toDataURL();
            _this.drawSignatureIsDirty = !_this.signaturePad.isEmpty();
            _this.notifyChange();
        };
        _this.updateUploadSignature = function () {
            return new Promise(function (resolve) {
                setTimeout((0, mobx_1.action)(function () {
                    var canvas = _this.uploadCanvasRef.current;
                    var canvasContext = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
                    var image = _this.uploadedSignature;
                    if (canvas && canvasContext) {
                        _this.initialiseCanvas(canvas);
                        if (image) {
                            var canvasRatio = canvas.width / canvas.height;
                            var imageRatio = image.width / image.height;
                            var relativeRatio = canvasRatio > imageRatio ? "tall" : "wide";
                            var canvasWidth = canvas.width / exports.PIXEL_RATIO;
                            var canvasHeight = canvas.height / exports.PIXEL_RATIO;
                            if (relativeRatio === "tall") {
                                var proportionalWidth = imageRatio / canvasRatio;
                                canvasContext.drawImage(image, (canvasWidth - proportionalWidth * canvasWidth) / 2, 0, (proportionalWidth * canvas.width) / exports.PIXEL_RATIO, canvasHeight);
                            }
                            else {
                                var proportionalHeight = canvasRatio / imageRatio;
                                canvasContext.drawImage(image, 0, (canvasHeight - proportionalHeight * canvasHeight) / 2, canvasWidth, proportionalHeight * canvasHeight);
                            }
                            _this.uploadSignatureData = canvas.toDataURL();
                            _this.hasUploadedImage = true;
                        }
                        else {
                            _this.uploadSignatureData = "";
                            _this.hasUploadedImage = false;
                        }
                        resolve();
                    }
                }), 0);
            });
        };
        _this.initialiseDrawSignaturePad = function () {
            return new Promise(function (resolve) {
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    var canvas;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                canvas = this.drawCanvasRef.current;
                                if (!canvas) return [3, 2];
                                this.signaturePad = new signature_pad_1.default(canvas, {
                                    penColor: "#242C39",
                                    onBegin: this.clearSignatureError,
                                    onEnd: this.updateDrawSignature,
                                });
                                this.initialiseCanvas(canvas);
                                return [4, this.signaturePad.fromDataURL(this.drawSignatureData, {
                                        width: canvas.width / exports.PIXEL_RATIO,
                                        height: canvas.height / exports.PIXEL_RATIO,
                                    })];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                resolve();
                                return [2];
                        }
                    });
                }); }, 0);
            });
        };
        _this.notifyChange = function () {
            var _a, _b;
            var _c = _this, disclaimerAccepted = _c.disclaimerAccepted, onChange = _c.props.onChange;
            var signature = (_a = {},
                _a[SignatureTab.Type] = _this.typeSignatureData,
                _a[SignatureTab.Draw] = _this.drawSignatureData,
                _a[SignatureTab.Upload] = _this.uploadSignatureData,
                _a[SignatureTab.Prefill] = _this.prefilledSignatureData,
                _a)[_this.currentTab];
            var method = (_b = {},
                _b[SignatureTab.Type] = SignatureInputMethod.Typed,
                _b[SignatureTab.Draw] = SignatureInputMethod.Drawn,
                _b[SignatureTab.Upload] = SignatureInputMethod.Uploaded,
                _b[SignatureTab.Prefill] = SignatureInputMethod.Prefilled,
                _b)[_this.currentTab];
            _this.clearSignatureError();
            _this.clearDisclaimerError();
            onChange({ signature: signature, method: method, disclaimerAccepted: disclaimerAccepted });
        };
        _this.handleUploadImage = function (files) { return __awaiter(_this, void 0, Promise, function () {
            var file, tempImage;
            var _this = this;
            return __generator(this, function (_a) {
                if (files.length === 0) {
                    return [2];
                }
                file = files[0];
                if (!["image/png", "image/jpeg"].includes(file.type)) {
                    this.setSignatureError("File must be a .png or .jpeg");
                    return [2];
                }
                if (file.size > exports.MAX_UPLOAD_SIZE_IN_MB * exports.MB_IN_BYTES) {
                    this.setSignatureError("File must be less than ".concat(exports.MAX_UPLOAD_SIZE_IN_MB, "MB"));
                    return [2];
                }
                tempImage = new Image();
                tempImage.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.uploadedSignature = tempImage;
                                return [4, this.updateUploadSignature()];
                            case 1:
                                _a.sent();
                                this.notifyChange();
                                return [2];
                        }
                    });
                }); };
                tempImage.src = URL.createObjectURL(files[0]);
                return [2];
            });
        }); };
        _this.chooseImageForUpload = function () {
            var tempUpload = document.createElement("input");
            tempUpload.type = "file";
            tempUpload.accept = "image/png, image/jpeg";
            tempUpload.style.display = "none";
            tempUpload.addEventListener("change", function (event) { return __awaiter(_this, void 0, void 0, function () {
                var files;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            files = event.target.files;
                            if (!files) return [3, 2];
                            return [4, this.handleUploadImage(files)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            document.body.removeChild(tempUpload);
                            return [2];
                    }
                });
            }); });
            document.body.appendChild(tempUpload);
            tempUpload.click();
        };
        _this.clearCurrentTab = function () {
            var currentTab = _this.currentTab;
            if (currentTab === SignatureTab.Type) {
                _this.updateTypeSignature("");
            }
            else if (currentTab === SignatureTab.Draw) {
                _this.signaturePad.clear();
                _this.updateDrawSignature();
            }
            else if (currentTab === SignatureTab.Upload) {
                _this.uploadedSignature = undefined;
                _this.updateUploadSignature();
            }
        };
        _this.handleUploadDragOver = function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.dataTransfer.dropEffect = "copy";
            _this.isDraggingOverUpload = true;
        };
        _this.handleUploadDragLeave = function () {
            _this.isDraggingOverUpload = false;
        };
        _this.handleUploadDrop = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.isDraggingOverUpload = false;
                        return [4, this.handleUploadImage(event.dataTransfer.files)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); };
        _this.toggleDisclaimer = function () {
            _this.disclaimerAccepted = !_this.disclaimerAccepted;
            _this.notifyChange();
        };
        _this.renderPrintMode = function () {
            var visualMode = _this.props.visualMode;
            return (react_1.default.createElement("div", { className: (0, classnames_1.default)([styles.wrapper({ visualMode: visualMode, isPrintMode: true }), "accept-form-esignature"]) },
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Signature *", size: kaleidoscope_1.TextInputSize.Small }),
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Date *", size: kaleidoscope_1.TextInputSize.Small })));
        };
        var registerImperativeHandlers = props.registerImperativeHandlers;
        registerImperativeHandlers({
            validate: _this.handleValidate,
            devFill: _this.handleDevFill,
            previewAutoFill: _this.handleDevFill,
        });
        return _this;
    }
    Esign.prototype.componentDidMount = function () {
        var _this = this;
        this.prefillSignatureChangedDisposer = pages_common_1.PubSub.subscribe("qwilr:prefilled-signature-changed", function (_a) {
            var signature = _a.signature;
            return _this.handlePrefilledSignature(signature);
        });
    };
    Esign.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.prefillSignatureChangedDisposer) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    Object.defineProperty(Esign.prototype, "currentTabIsPopulated", {
        get: function () {
            var _a;
            return (_a = {},
                _a[SignatureTab.Type] = !!this.typeSignature,
                _a[SignatureTab.Draw] = this.drawSignatureIsDirty,
                _a[SignatureTab.Upload] = this.hasUploadedImage,
                _a[SignatureTab.Prefill] = !!this.prefilledSignatureData,
                _a)[this.currentTab];
        },
        enumerable: false,
        configurable: true
    });
    Esign.prototype.render = function () {
        var _a;
        var _this = this;
        if (this.props.printMode) {
            return this.renderPrintMode();
        }
        return (react_1.default.createElement("div", { className: styles.wrapper({ visualMode: this.props.visualMode }) },
            this.showSignaturePad && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: styles.header },
                    react_1.default.createElement("div", { className: "label" }, "E-signature"),
                    react_1.default.createElement("div", { className: "label" }, new Date(Date.now()).toLocaleDateString())),
                react_1.default.createElement("div", { className: styles.card({ invalid: !!this.signatureError }) },
                    react_1.default.createElement(kaleidoscope_1.Tabs, { selectedIndex: this.currentTab === SignatureTab.Prefill ? 0 : exports.orderedSignatureTabs.indexOf(this.currentTab), onChange: function (tabIndex) {
                            _this.changeTab(exports.orderedSignatureTabs[tabIndex]);
                        } },
                        react_1.default.createElement("div", { className: styles.cardHeader },
                            react_1.default.createElement(kaleidoscope_1.TabList, { "aria-label": "Signature type" },
                                react_1.default.createElement(kaleidoscope_1.Tab, null, "Type"),
                                react_1.default.createElement(kaleidoscope_1.Tab, null, "Draw"),
                                react_1.default.createElement(kaleidoscope_1.Tab, null, "Upload")),
                            react_1.default.createElement("div", { className: styles.actions },
                                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, disabled: !this.currentTabIsPopulated, onClick: this.clearCurrentTab }, "Clear"))),
                        react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true },
                            react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "type" }) },
                                react_1.default.createElement("div", { className: styles.inputWrapper },
                                    react_1.default.createElement("input", { className: styles.input, placeholder: "Type your signature", value: this.typeSignature, onChange: function (e) {
                                            _this.updateTypeSignature(e.currentTarget.value);
                                        } })),
                                react_1.default.createElement("canvas", { ref: this.typeCanvasRef, className: styles.canvas({ mode: "type" }) })),
                            react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "draw" }) },
                                react_1.default.createElement("div", { className: styles.inputWrapper },
                                    react_1.default.createElement("div", { className: styles.input })),
                                react_1.default.createElement("canvas", { ref: this.drawCanvasRef, className: styles.canvas({ mode: "draw" }) })),
                            react_1.default.createElement(kaleidoscope_1.TabPanel, { className: styles.tabPanel({ mode: "upload" }) },
                                react_1.default.createElement("div", { className: styles.uploadWrapper({ hasUploaded: this.hasUploadedImage }), onDragOver: this.handleUploadDragOver, onDragLeave: this.handleUploadDragLeave, onDrop: this.handleUploadDrop },
                                    react_1.default.createElement("div", { className: styles.upload({ draggedOver: this.isDraggingOverUpload }) },
                                        react_1.default.createElement("div", { className: styles.uploadDescription },
                                            react_1.default.createElement("div", { className: "text-medium-label" }, "Drag a file here"),
                                            react_1.default.createElement("div", { className: "text-description" }, "Must be a .png or .jpg")),
                                        react_1.default.createElement(kaleidoscope_1.Button, { onClick: this.chooseImageForUpload, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "Browse files"))),
                                react_1.default.createElement("canvas", { ref: this.uploadCanvasRef, className: styles.canvas({ mode: "upload", hasUploaded: this.hasUploadedImage }) }))))))),
            this.SHOW_DEBUG_PREVIEW && (react_1.default.createElement("img", { style: { outline: "1px solid red" }, src: (_a = {},
                    _a[SignatureTab.Type] = this.typeSignatureData,
                    _a[SignatureTab.Draw] = this.drawSignatureData,
                    _a[SignatureTab.Upload] = this.uploadSignatureData,
                    _a[SignatureTab.Prefill] = "",
                    _a)[this.currentTab] })),
            react_1.default.createElement("div", { className: styles.disclaimer({ invalid: !!this.disclaimerError }) },
                react_1.default.createElement(kaleidoscope_1.Checkbox, { labelHidden: true, label: "Accept disclaimer", id: "disclaimer", checked: this.disclaimerAccepted, onChange: this.toggleDisclaimer, size: "m" }),
                react_1.default.createElement("div", { className: styles.disclaimerText, dangerouslySetInnerHTML: { __html: this.props.disclaimerText }, onClick: function (event) {
                        if (event.target.tagName === "A") {
                            return;
                        }
                        _this.toggleDisclaimer();
                    } }))));
    };
    __decorate([
        (0, inversify_react_1.resolve)("setErrorMsg"),
        __metadata("design:type", Function)
    ], Esign.prototype, "setErrorMsg", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "currentTab", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], Esign.prototype, "disclaimerAccepted", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "typeSignature", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "drawSignatureIsDirty", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "isDraggingOverUpload", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "hasUploadedImage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "signatureError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "disclaimerError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], Esign.prototype, "showSignaturePad", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handlePrefilledSignature", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handleDevFill", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "setSignatureError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "setDisclaimerError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "clearSignatureError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "clearDisclaimerError", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "changeTab", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "updateTypeSignature", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "updateDrawSignature", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "updateUploadSignature", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handleUploadImage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "chooseImageForUpload", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Esign.prototype, "currentTabIsPopulated", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "clearCurrentTab", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handleUploadDragOver", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handleUploadDragLeave", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "handleUploadDrop", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Esign.prototype, "toggleDisclaimer", void 0);
    Esign = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Esign);
    return Esign;
}(react_1.default.Component));
exports.default = Esign;
